export const metadata = {
  title: `Not available on mobile devices`,
  description: `Not available on mobile devices`,
};

export default function NotAvailableOnMobile() {
  return (
    <div className="flex h-screen flex-col-reverse items-center justify-center gap-16 px-4 py-24 md:gap-28 md:px-44 md:py-20 lg:flex-row lg:px-24 lg:py-24">
      <div className="m-auto w-full xl:w-2/3">
        <h1 className="my-2 text-2xl font-bold text-gray-800">
          This feature is unavailable on mobile devices
        </h1>
        <p className="my-2 text-gray-800">
          We apologize for the inconvenience. Please access this feature using a
          desktop or tablet device for the best experience.
        </p>
        <a
          type="button"
          className=" my-2 rounded  border bg-gray-900 px-8 py-4 text-center text-white hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-700 focus:ring-opacity-50 sm:w-full lg:w-auto"
          href="/"
        >
          Go back to the homepage
        </a>
      </div>
    </div>
  );
}
